export enum TimePeriod {
  ALL = "all",
  TODAY = "today",
  WEEK = "week",
  MONTH = "month",
  YEAR = "year",
  CUSTOM = "custom",
}

export enum CompletionStatus {
  ALL = "all",
  COMPLETED = "completed",
  NOT_COMPLETED = "not-completed",
}

export enum ViewMode {
  COMPRESSED = "compressed",
  TIMELINE = "timeline",
}

export enum OverrunThreshold {
  PERCENTAGE = 1.2, // 20% longer than estimated
}

export enum TimeDeviationCategory {
  PERFECT = 1.05, // ≤105%
  GREAT = 1.1, // 105-110%
  GOOD = 1.2, // 110-120%
  OVERRUN = 1.2, // >120% (same as GOOD threshold)
}
